module.exports = __webpack_public_path__ + "img/happy.2967163e.gif";